<form [formGroup]="formGroup">
  <div class="card">
    <div class="row card-body">
      <div class="d-flex flex-column mb-3">
        <p class="h4 m-0">Data e horário</p>
        <p class="text-secondary">
          Escolha quando seu evento começará e terminará para que os participantes possam se programar.
        </p>
      </div>

      <!-- INÍCIO -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="form-label" for="startDateTime">Data e Hora de Início</label>

          <p-datepicker
            appDatepickerMask
            inputStyleClass="w-100"
            class="w-100"
            inputId="startDateTime"
            formControlName="startDateTime"
            [showTime]="true"
            [hourFormat]="'24'"
            [showIcon]="true"
            [appendTo]="'body'"
            [iconDisplay]="'input'"
            [selectOtherMonths]="true"
            [minDate]="!allowPastDates ? dateNow : null"
            class="w-100"
            [class.ng-dirty]="formGroup.controls.startDateTime.touched"
            [class.ng-invalid]="formGroup.controls.startDateTime.touched && formGroup.controls.startDateTime.invalid" />

          @if (formGroup.controls.startDateTime.touched && formGroup.controls.startDateTime.hasError("required")) {
            <div class="invalid-feedback d-block">A data/hora de início é obrigatória.</div>
          }

          @if (formGroup.touched && formGroup.hasError("dateBeforeCurrent")) {
            <div class="invalid-feedback d-block">
              As datas de início e/ou término não podem ser antes da data atual.
            </div>
          }

          @if (formGroup.touched && formGroup.hasError("datesAreEqual")) {
            <div class="invalid-feedback d-block">As datas de início e término não podem ser iguais.</div>
          }
        </div>
      </div>

      <!-- TÉRMINO -->
      <div class="col-12 col-lg-6">
        <div class="form-group">
          <label class="form-label" for="endDateTime">Data e Hora de Término</label>

          <p-datepicker
            appDatepickerMask
            inputStyleClass="w-100"
            class="w-100"
            inputId="endDateTime"
            formControlName="endDateTime"
            [showTime]="true"
            [hourFormat]="'24'"
            [showIcon]="true"
            [appendTo]="'body'"
            [iconDisplay]="'input'"
            [selectOtherMonths]="true"
            class="w-100"
            [minDate]="formGroup.controls.startDateTime.value"
            [class.ng-dirty]="formGroup.controls.endDateTime.touched"
            [class.ng-invalid]="formGroup.controls.endDateTime.touched && formGroup.controls.endDateTime.invalid" />

          @if (formGroup.controls.endDateTime.touched && formGroup.controls.endDateTime.hasError("required")) {
            <div class="invalid-feedback d-block">A data/hora de término é obrigatória.</div>
          }

          @if (formGroup.touched && formGroup.hasError("dateEndBeforeStart")) {
            <div class="invalid-feedback d-block">A data de término não pode ser antes da data de início.</div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
